import { useState } from "react"
import { Box, CircularProgress, Stack, Paper, Typography } from "@mui/material"

import { GoogleLogin } from "@react-oauth/google"

import { Navigate, useNavigate } from "react-router-dom"

import { PLogo } from "../../components/PLogo/PLogo"

import { strings } from "../../config/strings"

import { useAuth } from "../../hooks/useAuth"
import { googleAuthRequest } from "../../utils/api"


export const LoginPage = () => {
    
    //State

    const [authenticating, setAuthenticating] = useState(false)


    //Hooks

    const auth = useAuth()
    const navigate = useNavigate()

   
    //Handlers

    const handleGoogleLoginSuccess = async (credentialResponse:any) => {

        try {
            setAuthenticating(true)

            await googleAuthRequest(credentialResponse.credential)
            
            const user = auth.getCurrentUser()
            auth.setUser(user)

            navigate('/')
        }
        catch(e){
            console.log(e)
        }
        finally{
            setAuthenticating(false)
        }
    }

    const handleGoogleLoginError = () => {
        console.log('Google SSO failed')
    }    


    //Render

    if(auth.getCurrentUser()) {
        return <Navigate to="/" />
    }

    return (
        <Box 
            display='flex'
            minHeight='100vh'
            justifyContent='center'
            alignItems='center'
        >
            <Paper>
                <Stack spacing={4} p={4} alignItems='center'>
                    <PLogo/>
                    <Typography variant="h6">{strings.signin}</Typography>
                    <Box sx={{display: 'inline-block'}}>
                        {
                            authenticating?
                            (   
                                <Box width={200} textAlign='center'>
                                    <CircularProgress size={38}/>
                                </Box>
                            ):
                            (
                                <GoogleLogin 
                                    onSuccess={handleGoogleLoginSuccess} 
                                    onError={handleGoogleLoginError}
                                />
                            )
                        }   
                    </Box>
                </Stack>
            </Paper>
        </Box>
    )
}